import { Autocomplete, TextField } from '@mui/material';
import ErrorSupportForAllMui from 'Global/Components/CommonComponents/ErrorSupportForAllMui/ErrorSupportForAllMui';
import { makeStyles } from '@mui/styles';

import React, { useEffect } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const useStyles = makeStyles((theme) => ({
  inputFocused: {
    marginTop: '-.5em',
  },
  inputRoot: {
    maxHeight: '40px',
  },
  root: {
    maxHeight: '40px',
  },
}));

const EditableCustomizableAutoComplete = ({
  name,
  SelectableDataArray,
  isEnglish = true,
  label,
  onChange,
  stateLift,
  completeOutPut = false,
  errors,
  defaultValue,
  isSmall = true,
  idOutput,
  initialOnChange = false,
}) => {
  const classes = useStyles();

  const labelStyles = {
    textAlign: isEnglish ? 'left' : 'right',
    right: isEnglish ? 'auto' : '42px',
    left: isEnglish ? 0 : 'auto',
    transformOrigin: isEnglish ? 'left' : 'right',
    '&.MuiInputLabel-shrink': {
      right: '32px !important',
    },
  };

  const autocompleteStyles = {
    maxHeight: '40px',
  };

  useEffect(() => {
    const newValue = defaultValue;
    if (onChange && initialOnChange) {
      if (
        SelectableDataArray?.filter(
          (fl) => fl.label === newValue
        )[0] === undefined
      ) {
        return;
      }
      idOutput
        ? onChange(
            SelectableDataArray?.filter(
              (fl) => fl.label === newValue
            )[0].id
          )
        : completeOutPut
        ? onChange(
            SelectableDataArray?.filter(
              (fl) => fl.label === newValue
            )
          )
        : onChange(newValue);
      stateLift &&
        stateLift(
          SelectableDataArray?.filter(
            (fl) => fl.label === newValue
          )
        );
    }
  }, [SelectableDataArray, initialOnChange]);

  return (
    <React.Fragment>
      <Autocomplete
        {...(isSmall && { size: 'small' })}
        onInputChange={(event, newValue) => {
          if (onChange) {
            if (
              SelectableDataArray?.filter(
                (fl) => fl.label === newValue
              )[0] === undefined
            ) {
              return;
            }
            idOutput
              ? onChange(
                  SelectableDataArray?.filter(
                    (fl) => fl.label === newValue
                  )[0].id
                )
              : completeOutPut
              ? onChange(
                  SelectableDataArray?.filter(
                    (fl) => fl.label === newValue
                  )
                )
              : onChange(newValue);
            stateLift &&
              stateLift(
                SelectableDataArray?.filter(
                  (fl) => fl.label === newValue
                )
              );
          }
        }}
        defaultValue={defaultValue}
        dir={isEnglish ? 'ltr' : 'rtl'}
        disablePortal
        id="combo-box-demo"
        options={SelectableDataArray}
        renderInput={(params) => (
          <TextField
            {...(isSmall && { size: 'small' })}
            color="colorPrimer"
            {...params}
            label={label}
            error={errors && !!errors[name]}
            InputLabelProps={{
              sx: {
                ...labelStyles,
                color:
                  errors && !!errors[name]
                    ? '#D32F2F !important'
                    : '',
              },
            }}
            InputProps={{
              ...params.InputProps,
              sx: {
                ...params.InputProps.sx,
                ...autocompleteStyles,
              },
            }}
          />
        )}
        renderOption={(props, option, index) => {
          const key = `listItem-${index}-${option.id}`;

          return (
            <li {...props} key={key}>
              {option.label}
            </li>
          );
        }}
        isOptionEqualToValue={(option, value) => {
          return (
            value.length !== 0 &&
            (option.label === value ||
              option.id === value.id ||
              ArabicToPersian(option.label) ===
                ArabicToPersian(value?.label))
          );
        }}
      />
      {errors && !!errors[name] ? (
        <ErrorSupportForAllMui label={label} />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default EditableCustomizableAutoComplete;
